import {
  HubSection,
  HubSectionStatus,
} from '@alucio/aws-beacon-amplify/src/models';

export const sortHubSectionsByOrder = <T extends Pick<HubSection, 'order'>>(
  sections: T[],
): T[] => sections.slice().sort((first, second) => first.order - second.order);

export const getSectionNavigationName = (
  sectionHeader: string | undefined,
  defaultName: string,
): string => sectionHeader || defaultName;

export const reconcileHubSections = (
  existingSections: HubSection[],
  submittedSections: Record<string, HubSection>,
  updatedAt = new Date().toISOString(),
): HubSection[] => {
  const existingSectionIds = new Set(existingSections.map(section => section.id));
  const reconciledSections = existingSections.map(section => {
    if (section.status !== HubSectionStatus.ACTIVE) return section;

    const submittedSection = submittedSections[section.id];
    return submittedSection
      ? { ...submittedSection, updatedAt }
      : { ...section, status: HubSectionStatus.DELETED, updatedAt };
  });

  Object.values(submittedSections).forEach(section => {
    if (!existingSectionIds.has(section.id)) reconciledSections.push(section);
  });

  return reconciledSections;
};
